import { Link } from "react-router-dom";

import { CurrencyTotalsTable } from "@/components/currency-totals-table";
import { FullPageSpinner } from "@/components/require-admin";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { QueryError } from "@/components/query-error";
import { useOverviewQuery } from "@/features/api";

export function OverviewPage() {
  const { data, isLoading, error, refetch, isRefetching } = useOverviewQuery();

  if (isLoading) return <FullPageSpinner />;
  if (error || !data) {
    return (
      <QueryError message="Özet yüklenemedi." onRetry={() => refetch()} retrying={isRefetching} />
    );
  }

  const o = data.organizers;
  const stats = [
    { label: "Toplam organizatör", value: o.total, to: "/organizers" },
    { label: "Aktif", value: o.active, to: "/organizers?status=Active" },
    {
      label: "E-posta doğrulanmadı",
      value: o.pendingEmailVerification,
      to: "/organizers?status=PendingEmailVerification",
    },
    { label: "Askıda", value: o.suspended, to: "/organizers?status=Suspended" },
    { label: "Son 30 günde yeni", value: o.newLast30Days },
    { label: "Son 30 günde satış yapan", value: o.sellingLast30Days },
    {
      label: "Ödeme onay bekliyor",
      value: data.payouts.awaitingApproval,
      to: "/payouts?status=Requested",
    },
    {
      label: "Ödeme EFT bekliyor",
      value: data.payouts.awaitingTransfer,
      to: "/payouts?status=Approved",
    },
  ];

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold tracking-tight">Platform özeti</h1>
        <p className="text-sm text-muted-foreground">
          Tüm organizatörler; tutarlar iade sonrası net, para birimleri ayrı.
        </p>
      </div>

      <div className="grid grid-cols-2 gap-3 md:grid-cols-4">
        {stats.map((s) => {
          const body = (
            <Card className="h-full gap-1 py-4 transition-colors hover:bg-muted/40">
              <CardContent className="px-4">
                <div className="text-2xl font-semibold tabular-nums">
                  {s.value.toLocaleString("tr-TR")}
                </div>
                <div className="text-xs text-muted-foreground">{s.label}</div>
              </CardContent>
            </Card>
          );
          return s.to ? (
            <Link key={s.label} to={s.to}>
              {body}
            </Link>
          ) : (
            <div key={s.label}>{body}</div>
          );
        })}
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Son 30 gün</CardTitle>
          <CardDescription>Ödeme zamanına göre.</CardDescription>
        </CardHeader>
        <CardContent>
          <CurrencyTotalsTable rows={data.last30Days} />
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>Tüm zamanlar</CardTitle>
        </CardHeader>
        <CardContent>
          <CurrencyTotalsTable rows={data.allTime} emptyText="Henüz satış yok." />
        </CardContent>
      </Card>
    </div>
  );
}
